export const ROUTES = {
    home: "/",
    details: "/details",
};